module.exports = __webpack_public_path__ + "img/bottomfigure.6d4c5f14.png";